import {SidebarLanguages as LanguagesComponent} from '@github-ui/code-view-sidebar/components/SidebarLanguages'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarLanguages({ownerLogin, repoName}: Props) {
  const {languages} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!languages) return null
  return <LanguagesComponent {...languages} />
}
